import React, { Component } from 'react';
import { Modal, Button,  DatePicker, message, Upload  } from 'antd';
import AjaxRequest, { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import PMRefuse from './PMRefuse';
import moment from 'moment';

const initialState = {
    investigationCode: '',
    investigationName: '',
    // investigationSiteCode: '',
    // investigationSiteName: '',
    assignedUsers: {},
    handoverBeginTime: '',
    handoverEndTime: '',
    localeHandoverBeginTime: '',
    localeHandoverEndTime: '',
    handoverLeaderConfirmDate: '',
    receiveLeaderConfirmDate: '',
    invAreaLeaderConfirmDate: '',
    visible: false,
    dateFormat: "YYYY-MM-DD",
    submitLoading: false,
    saveLoading: false,
    status: '',
    handoverUserId: '',
    isEdit: false,
    returnLoading: false,
    requirementId : '',
    submitting : false,
    confirmLoading: false,
    planFileList: [],
    reportFileList: [],
    recordData:{}
};

class PMreport extends Component {
    state = initialState;

    show = (record, isEdit) => {
        const { staffHandoverId } = record;
        const edit = isEdit ? true : false;
        this.setState({
            visible: true,
            requirement: {},
            fteList: [],
            city: '',
            requirementId : '',
            isEdit: edit,
            recordData:record
        });
        this.getEditData(record);
        this.loadData(staffHandoverId);
    };

    getEditData = (record) =>{
        const {
            status,
            staffHandoverId,
            createType,
            investigationCode,
            investigationName,
            handoverUserName,
            receiveUserName,
            handoverBeginTime,
            handoverEndTime,
            localeHandoverBeginTime,
            localeHandoverEndTime,	 
            handoverLeaderConfirmDate,
            receiveLeaderConfirmDate,
            invAreaLeaderConfirmDate,
        } = record;
        this.setState({
            status,
            staffHandoverId,
            createType,
            investigationCode,
            investigationName,
            handoverUserName,
            receiveUserName,
            handoverBeginTime: handoverBeginTime ? moment(handoverBeginTime).format(initialState.dateFormat) : "",
            handoverEndTime: handoverEndTime ? moment(handoverEndTime).format(initialState.dateFormat) : "",
            localeHandoverBeginTime: localeHandoverBeginTime ? moment(localeHandoverBeginTime).format(initialState.dateFormat) : "",
            localeHandoverEndTime: localeHandoverEndTime ? moment(localeHandoverEndTime).format(initialState.dateFormat) : "",
            handoverLeaderConfirmDate: handoverLeaderConfirmDate ? moment(handoverLeaderConfirmDate).format(initialState.dateFormat) : "",
            receiveLeaderConfirmDate: receiveLeaderConfirmDate ? moment(receiveLeaderConfirmDate).format(initialState.dateFormat) : "",
            invAreaLeaderConfirmDate: invAreaLeaderConfirmDate ? moment(invAreaLeaderConfirmDate).format(initialState.dateFormat) : "",
        })
    }

    reset = () => {
        this.setState(initialState);
        this.props.reload();
    }

    hide = () => {
        this.setState({ visible: false });
    };

    dateChange = (field, value) =>{
        const { dateFormat } = this.state;
        this.setState({ [field] : value ? moment(value).format(dateFormat): null });
    }

    getDate = (date) =>{
        const { dateFormat } = this.state;
        if (date) {
            return moment(date).format(dateFormat)
        } else {
            return "";
        }
        
    }

    getDatePicker = (date, name) =>{
        const { dateFormat } = this.state;
        if (date == null) {
            return (<DatePicker onChange={this.dateChange.bind(this, name)} format={dateFormat} />)
        } else {
            return (<DatePicker onChange={this.dateChange.bind(this, name)} value={date ? moment(date) : null} format={dateFormat} />)
        }
        
    }

    handleSubmitAjax = (nodeliver) => {
        const { 
            requirementId, 
            handoverBeginTime , 
            handoverEndTime, 
            localeHandoverBeginTime, 
            localeHandoverEndTime, 
            planFileList, 
            reportFileList,
            createType,
            handoverLeaderConfirmDate,
            receiveLeaderConfirmDate
        } = this.state;
        const loading = nodeliver ? "saveLoading" : "submitLoading";
        this.setState({ [loading] : true });
        if(loading == "submitLoading"){
            if (planFileList.length <= 0) {
                message.error(`请上传PM工作交接计划附件`);
                this.setState({ [loading]: false});
                return;
            } else if (reportFileList <= 0) {
                message.error(`请上传PM工作交接报告附件`);
                this.setState({ [loading]: false});
                return;
            }

            let errMsg = "";
            if(!handoverBeginTime){
                errMsg += "交接开始日期 "
            }
            if(!handoverEndTime){
                errMsg += "交接结束日期 "
            }
            if(!localeHandoverBeginTime){
                errMsg += "现场交接开始日期 "
            }
            if(!localeHandoverEndTime){
                errMsg += "现场交接结束日期 "
            }
            
            if(!handoverBeginTime || !handoverEndTime || !localeHandoverBeginTime || !localeHandoverEndTime){
                message.error(`请填写${errMsg}`);
                this.setState({ [loading]: false});
                return;
            }
        }
        const options = {
            method: 'POST',
            url: `${API_URL.execute.staffHandoversaveHandoverReport}`,
            data:{
                staffHandoverId:requirementId,
                handoverBeginTime,
                handoverEndTime,
                localeHandoverBeginTime,
                localeHandoverEndTime,
                createType,
                commitReport:loading == "submitLoading"?'commitReport':'',
                handoverLeaderConfirmDate,
                receiveLeaderConfirmDate
            },
            doneResult: data => {
                this.setState({ [loading]: false});
                message.success('提交成功');
                this.props.reload();
                this.reset();
            },
            errorResult: data => {
                this.setState({ [loading]: false});
            },
        };
        AjaxRequest.sendRequest(options);
    }

    handleSave = () => {
        this.handleSubmitAjax(true);
    }

    handleSubmit = () => {
        this.handleSubmitAjax(false);
    }

    confirmCompleteReport = () =>{
        Modal.confirm({
            title: '确认完成',
            content: (<span className="confirmText">确认该交接报告完成?</span>),
            okText: '确认',
            cancelText: '取消',
            onOk: this.submitCompleteReport
        });
    }

    submitCompleteReport = () => {
        const {requirementId, status, submitLoading } = this.state;
        this.setState({submitLoading:true})
        const options = {
            method: 'POST',
            url: `${API_URL.execute.confirmPMHandoverReport}`,
            data:{
                staffHandoverId:requirementId,
                status,
                approveStatus:'AGREE',
            },
            doneResult: data => {
                this.setState({submitLoading:false})
                message.success('操作成功');
                this.reset();
            },
        };
        AjaxRequest.sendRequest(options);
    }

    refuseTransfer = ( id, status )=> {
        this.refuseTransferRef.show(id, status);
    }

    getAssignUserNames = () =>{
        const {assignedUsers} = this.state;
        let Users = "";
        for(let key in assignedUsers){
            Users += assignedUsers[key] + ";";
        }
        var lastIndex = Users.lastIndexOf(";");
        Users = Users.substring(0, lastIndex);
        return Users;
    }

    isAssignUser = () =>{
        const {assignedUsers} = this.state;
        const userId = sessionStorage.userId;
        let UserIds = [];
        for(let key in assignedUsers){
            UserIds.push(key);
        }
        if(UserIds.indexOf(userId) < 0){
            return false;
        }else{
            return true;
        }
    }

    loadData = id => {
        this.setState({
            processedEmployees : [],
            requirement: null,
            fteList : [],
            city : '',
            employees : [],
            requirementId : id,
            employeesLoading : true,
        })
        const options = {
            method: 'POST',
            url: API_URL.execute.queryInvDetailForReport,
            data:{
                staffHandoverId:id
            },
            doneResult: ( res => {
                    const {data} = res;
                    const { planFileList, reportFileList } = data;
                    planFileList.forEach((el,index) => {
                        el.uid = index;
                    })
                    reportFileList.forEach((el,index) => {
                        el.uid = index;
                    })
                    this.setState({ ...data,planFileList,reportFileList });
                }
            ),
        };
        AjaxRequest.sendRequest(options);
    }

    loadFileList = () => {
        const { investigationJdeContractId } = this.state.jdeData;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeCodeEnclosure,
            data: {
                investigationJdeContractId,
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.data;
                fileList.forEach((item, index) => {
                    item.response = {fileMetaId: item.id};
                    item.uid = index;
                });
                this.setState({ fileList });
            }
        }
        AjaxRequest.sendRequest(options)
    }

    beforeUpload = (file, type) => {
        const { planFileList = [], reportFileList = [] } = this.state;
        const isLt20M = file.size / 1024 / 1024 <= 50;
        if (!isLt20M) {
            message.warning('文件大小不能超过50M');
            return false;
        }
        if (planFileList.length >= 10 || reportFileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
    };

    handleChange = ({file, fileList}, type) => {
        if (type == 'plan') {
            if (file.status == "done") {
                if (file.response.error) {  
                    message.error(file.response.error);
                    file.status = 'removed';
                    const fileData = [...this.state.planFileList];
                    const index = fileData.indexOf(file);
                    fileList.splice(index, 1);
                } else if (file.response.success) {
                    message.success('上传附件成功');
                }
            }
            this.setState({ planFileList: fileList });
        } else if (type == 'report') {
            if (file.status == "done") {
                if (file.response.error) {  
                    message.error(file.response.error);
                    file.status = 'removed';
                    const fileData = [...this.state.reportFileList];
                    const index = fileData.indexOf(file);
                    fileList.splice(index, 1);
                } else if (file.response.success) {
                    message.success('上传附件成功');
                }
            }
            this.setState({ reportFileList: fileList });
        }
    }

    handleRemove = file => {
        const options = {
            method: 'POST',
            url: API_URL.execute.deleteEnclosureFile,
            data: {
                fileMetaId: file.fileMateId ? file.fileMateId:file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message.error(res.error);
                } else {
                    message.success(res.success);
                }
            }
        };
        AjaxRequest.sendRequest(options);
    }

    getNodeList = (list) => {
        let data;
        if (list.length > 0) {
            data = list.map(item => <span key={item.fileMetaId}><a onClick={e => this.downLoadFile(e, item.fileMateId)}>{item.name}</a><br/></span>);
        }
        return data;
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: fileMetaId}, null, url);
    }

    render() {
        const {
            handoverUserId,
            submitLoading,
            saveLoading,
            status,
            isEdit,
            returnLoading,
            requirementId,
            confirmLoading,
            visible,
            createType,
            investigationCode,
            investigationName,
            receiveUserName,
            handoverUserName,
            actualDropNum,
            actualFilterNum,
            actualInformedNum,
            actualRandomNum,
            actualSAENum,
            actualViolationNum,
            actualVisitNum,
            planFileList,
            reportFileList,
            planFilterNum,
            planInformedNum,
            planRandomNum,
            handoverBeginTime,
            handoverEndTime,
            localeHandoverBeginTime,
            localeHandoverEndTime,
            handoverLeaderConfirmDate,
            receiveLeaderConfirmDate,
            invAreaLeaderConfirmDate,
            recordData
        } = this.state;
        const { canConfirmHandover , canConfirmReceive, canConfirmInvAreaLeader} = recordData;
        let footerDom;
        const mastSpan = (<span style={{color:'red'}}>* </span>)
        if( isEdit ){
            footerDom = [
                <Button key="handleSubmit" type="primary" size="large" loading={submitLoading} onClick={this.handleSubmit}>
                    保存并提交
                </Button>,
                <Button key="save" type="primary" size="large" loading={saveLoading} onClick={this.handleSave}>
                    保存
                </Button>,
                <Button key="back" size="large" onClick={this.hide}>取消</Button>,
            ];
        }else if(canConfirmInvAreaLeader || canConfirmHandover || canConfirmReceive){
            footerDom = [
                <Button  key="submit" type="primary" loading={submitLoading} onClick={this.confirmCompleteReport}>
                    确认
                </Button>,
                <Button key="back" loading={returnLoading} onClick={() => this.refuseTransfer(requirementId, status)}>打回</Button>,
            ];
        }else{
            footerDom = [
                <Button key="back" size="large" onClick={this.hide}>关闭</Button>
            ];
        }
        const title = isEdit ? "填写交接报告" : "查看交接报告" ;
        return (
            <div>
            <Modal
                visible={visible}
                title={title}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                width="1000px"
                bodyStyle={{ maxHeight: 600 }}
                confirmLoading={confirmLoading}
                footer={footerDom}
            >
                <div className="cont-cont"  style={{ marginTop: 10 }}>
                    <ul className="preview-list">
                        <li className="title preview-item"><h4>1.基本信息</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }} >项目编号</label>
                                <span className="ui-text">{investigationCode}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>项目简称</label>
                                <span className="ui-text">{investigationName}</span>
                            </div>
                        </li>
                        {/* <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>中心编号</label>
                                <span className="ui-text">{investigationSiteCode}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>中心名称</label>
                                <span className="ui-text">{investigationSiteName}</span>
                            </div>
                        </li> */}
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>前任PM</label>
                                <span className="ui-text">{handoverUserName}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>现任PM</label>
                                <span className="ui-text">
                                    {receiveUserName}
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>计划筛选数</label>
                                <span className="ui-text">{planFilterNum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>实际筛选数</label>
                                <span className="ui-text">{actualFilterNum}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>计划知情数</label>
                                <span className="ui-text">{planInformedNum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>实际知情数</label>
                                <span className="ui-text">{actualInformedNum}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>计划随机(入组)数</label>
                                <span className="ui-text">{planRandomNum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>实际随机(入组)数</label>
                                <span className="ui-text">{actualRandomNum}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>病人退出数</label>
                                <span className="ui-text">{actualDropNum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>方案违背数</label>
                                <span className="ui-text">{actualViolationNum}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>SAE数</label>
                                <span className="ui-text">{actualSAENum}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>完成访视数</label>
                                <span className="ui-text">{actualVisitNum}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <hr />
                <div className="cont-cont" style={{ marginTop: 10 }}>
                    <h3>2.附件</h3>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label"  style={{ width: 150 }}>{ isEdit && mastSpan}PM工作交接计划</label>
                                <span className="ui-text" style={{width: 400}}>
                                    {
                                        isEdit
                                        ?
                                            <Upload
                                                action={API_URL.execute.uploadEnclosureFile}
                                                data={{
                                                    relateId:requirementId,
                                                    uploadType:'PM_HANDOVER_PLAN',
                                                    path: Date.now(),
                                                    curUserId: sessionStorage.userId,
                                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                                }}
                                                beforeUpload={(file) => this.beforeUpload(file, 'plan')}
                                                onChange={({file, fileList}) =>this.handleChange({file, fileList}, 'plan')}
                                                onRemove={this.handleRemove}
                                                fileList={planFileList}
                                                headers={xToken}
                                            >
                                                <Button style={{width: 80}}>选择文件</Button>
                                            </Upload>
                                        :
                                            planFileList && this.getNodeList(planFileList)
                                    } 
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150}}>{isEdit && mastSpan}PM工作交接报告</label>
                                <span className="ui-text" style={{width: 400}}>
                                    {
                                        isEdit
                                        ?
                                            <Upload
                                                action={API_URL.execute.uploadEnclosureFile}
                                                data={{
                                                    relateId:requirementId,
                                                    uploadType:'PM_HANDOVER_REPORT',
                                                    path: Date.now(),
                                                    curUserId: sessionStorage.userId,
                                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                                }}
                                                beforeUpload={(file) => this.beforeUpload(file, 'report')}
                                                onChange={({file, fileList}) =>this.handleChange({file, fileList}, 'report')}
                                                onRemove={this.handleRemove}
                                                fileList={reportFileList}
                                                headers={xToken}
                                            >
                                                <Button style={{width: 80}}>选择文件</Button>
                                            </Upload>
                                        :
                                            reportFileList && this.getNodeList(reportFileList)
                                    }
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <hr />
                <div className="cont-cont" style={{ marginTop: 10 }}>
                    <h3>3.交接确认</h3>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>{mastSpan}交接开始日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(handoverBeginTime, "handoverBeginTime")
                                    :
                                    this.getDate(handoverBeginTime)
                                    }
                                </div>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>{mastSpan}交接结束日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(handoverEndTime, "handoverEndTime")
                                    :
                                    this.getDate(handoverEndTime)}
                                </div>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>{mastSpan}现场交接开始日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(localeHandoverBeginTime, "localeHandoverBeginTime")
                                    :
                                    this.getDate(localeHandoverBeginTime)}
                                </div>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>{mastSpan}现场交接结束日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(localeHandoverEndTime, "localeHandoverEndTime")
                                    :
                                    this.getDate(localeHandoverEndTime)}
                                </div>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>交接PM上级确认日期</label>
                                <div className="ui-text">
                                    {isEdit && createType == 'IMPORT_DATA' ?
                                        this.getDatePicker(handoverLeaderConfirmDate, "handoverLeaderConfirmDate")
                                    :
                                    (this.getDate(handoverLeaderConfirmDate) || '-')}
                                </div>
                            </div>
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>接收PM上级确认日期</label>
                                <div className="ui-text">
                                    {isEdit && createType == 'IMPORT_DATA'  ?
                                        this.getDatePicker(receiveLeaderConfirmDate, "receiveLeaderConfirmDate")
                                    :
                                    (this.getDate(receiveLeaderConfirmDate) || '-')}
                                </div>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{ width: 150 }}>领域leader确认日期</label>
                                <div className="ui-text">
                                    {this.getDate(invAreaLeaderConfirmDate) || '-'}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
            <PMRefuse
                ref={el => { this.refuseTransferRef = el; }}
                reload={this.reset}
            />
            </div>
        );
    }
}

export default PMreport;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/PMReport.js